export default __webpack_public_path__ + "media/images/jvqmap/marker/green-40b71c07afe112e20043f10fc3453f81.png";